    function populateSoNum(theNum) {	
      //console.log(theNum);	
      $('#salesOrder').val(theNum);	
      document.salesOrderForm.submit();	
    }	
(($) => {
  $(document).ready(() => {
    //MTG ADDED	
    $('#labConstr a').html('Features');
    $('#tabWarranty').append('<p>Furniture Fair cares and will assist you with any manufacturer warranty claims or direct you to the appropriate party. We also offer the Montage Protection Plan or the Furniture Fair Service Agreement* for an additional cost.<br><br>For answers to all your warranty questions, please call the Customer Care Department at 513-874-5553. Customer Care hours are Monday through Saturday (11 a.m. to 8 p.m) and Sunday (11 a.m. to 6 p.m).<br><br><em>*Furniture Fair Service Agreement applies only to Select Clearance and As Is merchandise.</em> ');

    var myApi = '81C7ABF9BDBDEB89939DBA04D4EF47BC81C7ABFAECA6F65ED454CBDF3815F0B4';
    var vMny = $('.current_price .money').html();

    if (vMny != undefined) {
      if (vMny.search("9.99") > 0) {
        $('#tabWarranty').hide();
        $('#labacc4').hide();
      }
    }

    function getSku() {
      var thesku = $('#skuItmCd').html();
      return thesku;
    }
    $('.swatch-element').click(function () {

      $(".the-product-item").hide();
      $("#the-product-" + $(this).attr('data-id')).show();
      var vSwatch = $(this).attr('data-value');

      $('#hiddenSelectedSwatch').val(vSwatch);
      $("#avail-detail-info").hide("slow", function () {
        $('#stockSymbol').removeClass('rotateDown');
      });
      $("#foundation-info").hide("slow", function () {
        $('#boxSymbol').removeClass('rotateDown');
        $('.foundation-detail').css('border-bottom', '1px solid silver');
      });
      $("#protector-info").hide("slow", function () {
        $('#proSymbol').removeClass('rotateDown');
        $('.protector-detail').css('border-bottom', '1px solid silver');
      });
    });
    $('#askQuestionBtn').click(function () {
      $('#askQuestionBtn').val('Sending Email...');
      $('#formSku').val(getSku());
      $('#formPageLink').val(window.location.href);
    });
    $('#question_form').on('submit', function (e) {
      $("#askQuestion").toggle("slow", function () {
        $('#contactFormMessage').val('');
        $('#askQuestionBtn').val('Ask Question');
      });
    });
    $('.avail-detail').click(function () {
      $('#avail-detail-info').toggle('slow');
      if ($('#stockSymbol').hasClass('rotateDown')) {
        $('#stockSymbol').removeClass('rotateDown');
        $(this).removeClass('backBoxG');
      } else {
        $(this).addClass('backBoxG');
        $('#stockSymbol').addClass('rotateDown');
        var sendsku = getSku();

        fetch("https://revyewed.com/cfc/available_cors.cfc?method=remoteGetLocation"
          + "&sku=" + encodeURIComponent(sendsku)
          + "&apiKey=" + encodeURIComponent(myApi))
        .then(response => response.json())
        .then(json => {

            console.log("JSON:", json);

            $('.xstores').html(json.LOCATION);
            $('.xstock').html(json.STOCK);

            if (json.STOCK && json.STOCK.startsWith("In Stock")) {
                $('.xDelCheck').show();
            } else {
                $('.xDelCheck').hide();
            }

        })
        .catch(error => console.error("Fetch error:", error));

      }
    });
    $('.avail-detail').click(function (e) {
      var zx = $('#delCheck').val();
      getDelAvail(zx);
    });
    function getDelAvail(zx) {

      var tl = zx.length;

      if (tl === 5) {

        fetch("https://revyewed.com/cfc/available_cors.cfc?method=remoteGetAvailDel"
              + "&zip=" + encodeURIComponent(zx)
              + "&doc=1"
              + "&apiKey=" + encodeURIComponent(myApi),
        {
            method: "GET"
        })
        .then(function(response) {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.json();
        })
        .then(function(json) {

            console.log("Delivery JSON:", json);

            var s = '';

            if (Array.isArray(json) && json.length > 0) {

                for (var i = 0; i < json.length; i++) {

                    // Defensive checks so it never crashes
                    var d0 = json[i][0] || '';
                    var d1 = json[i][1] || '';
                    var d2 = json[i][2] || '';

                    s += '<div class="availDates">' + d0 + ' ' + d1 + ' ' + d2 + '</div>';
                }

                s += '<div class="delDisclaimer">*Delivery dates above are based on dates and stock available at this current time and are not guaranteed until checkout.</div>';

            } else {

                s = '<div class="availDates">We are sorry, we currently do not service your area of the country</div>';
            }

            $('#delCheckInfo').html(s);

        })
        .catch(function(error) {
            console.error("Fetch error:", error);
            $('#delCheckInfo').html('<div class="availDates">Unable to check delivery at this time.</div>');
        });

      } else {

        $('#delCheckInfo').html('');
      }
    }

    $('#delCheck').keyup(function (e) {
      var zx = this.value;
      getDelAvail(zx);
    });
    $('.foundation-detail').click(function () {
      $('#foundation-info').toggle('slow');
      if ($('#boxSymbol').hasClass('rotateDown')) {
        $('#boxSymbol').removeClass('rotateDown');
        $('#foundation-info').css('border-bottom', 'none');
        $('.foundation-detail').css('border-bottom', '1px solid silver');
        $(this).removeClass('backBoxG');
      } else {
        $(this).addClass('backBoxG');
        $('#boxSymbol').addClass('rotateDown');
        $('#foundation-info').css('border-bottom', '1px solid silver');
        $('.foundation-detail').css('border-bottom', 'none');
        var vSiz = $('.swatch_options input:checked').val();
        var vVen = $('#skuItmCd').html();

        fetch("https://revyewed.com/cfc/available_cors.cfc?method=remoteGetFoundation"
          + "&size=" + encodeURIComponent(vSiz)
          + "&sku=" + encodeURIComponent(vVen)
          + "&apiKey=" + encodeURIComponent(myApi),
            { method: "GET" }
        )
        .then(function(response) {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.json();
        })
        .then(function(json) {
            console.log("Foundation JSON:", json);

            var s = '<input type="radio" name="addFoundation" value="NONE" checked> No Foundation Selected<br>';

            if (Array.isArray(json) && json.length > 0) {
                for (var i = 0; i < json.length; i++) {

                    // Defensive extraction to avoid undefined values
                    var title   = json[i][0] || '';
                    var price   = json[i][1] != null ? parseFloat(json[i][1]).toFixed(2) : '0.00';
                    var handle  = json[i][2] || '';
                    var variant = json[i][5] || '';

                    s += '<input type="radio" name="addFoundation" ' +
                        'data-value="' + variant + '" ' +
                        'value="' + handle + '"> ' +
                        '<a target="_blank" href="/products/' + handle + '">' +
                        title + ' + $' + price +
                        '</a><br>';
                }
            }

            document.getElementById('foundation-info-detail').innerHTML = s;

        })
        .catch(function(error) {
            console.error("Fetch error:", error);
            document.getElementById('foundation-info-detail').innerHTML =
                '<div>Unable to load foundation options at this time.</div>';
        });
      }
    });
    $('.protector-detail').click(function () {
      $('#protector-info').toggle('slow');
      if ($('#proSymbol').hasClass('rotateDown')) {
        $('#proSymbol').removeClass('rotateDown');
        $('#protector-info').css('border-bottom', 'none');
        $('.protector-detail').css('border-bottom', '1px solid silver');
        $(this).removeClass('backBoxG');
      } else {
        $(this).addClass('backBoxG');
        $('#proSymbol').addClass('rotateDown');
        $('#protector-info').css('border-bottom', '1px solid silver');
        $('.protector-detail').css('border-bottom', 'none');
        var vVen = $('#skuItmCd').html();
        fetch("https://revyewed.com/cfc/available_cors.cfc?method=remoteGetAddOn&sku=" 
          + encodeURIComponent(vVen) 
          + "&apiKey=" + encodeURIComponent(myApi), 
        {
            method: "GET"
        })
        .then(function(response) {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.json();
        })
        .then(function(jpro) {

            console.log("Add-on JSON:", jpro);

            var p = '<input type="radio" name="addProtector" value="NONE" checked> No Protector Selected<br>';

            if (Array.isArray(jpro) && jpro.length > 0) {

                for (var i = 0; i < jpro.length; i++) {

                    // Defensive extraction
                    var title   = jpro[i][0] || '';
                    var handle  = jpro[i][2] || '';
                    var variant = jpro[i][5] || '';
                    var price   = jpro[i][7] || '0';

                    p += '<input type="radio" name="addProtector" ' +
                        'data-value="' + variant + '" ' +
                        'value="' + handle + '"> ' +
                        '<a target="_blank" href="/products/' + handle + '?variant=' + variant + '">' +
                        title + ' + $' + price +
                        '</a><br>';
                }
            }

            document.getElementById('protector-info-detail').innerHTML = p;

        })
        .catch(function(error) {
            console.error("Fetch error:", error);
            document.getElementById('protector-info-detail').innerHTML =
                '<div>Unable to load protection options at this time.</div>';
        });
      }
    });

    $('.power-detail').click(function () {
      $('#power-info').toggle('slow');
      if ($('#powSymbol').hasClass('rotateDown')) {
        $('#powSymbol').removeClass('rotateDown');
        $('#power-info').css('border-bottom', 'none');
        $('.power-detail').css('border-bottom', '1px solid silver');
        $(this).removeClass('backBoxG');
      } else {
        $(this).addClass('backBoxG');
        $('#powSymbol').addClass('rotateDown');
        $('#power-info').css('border-bottom', '1px solid silver');
        $('.power-detail').css('border-bottom', 'none');
        var vVen = $('#skuItmCd').html();

        fetch("https://revyewed.com/cfc/available_cors.cfc?method=remoteGetAddOn"
          + "&sku=" + encodeURIComponent(vVen)
          + "&apiKey=" + encodeURIComponent(myApi), 
        {
            method: "GET"
        })
        .then(function(response) {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.json();
        })
        .then(function(jpro) {

            console.log("Power Pack JSON:", jpro);

            var p = '<input type="radio" name="addPower" value="NONE" checked> No Power Pack Selected<br>';

            if (Array.isArray(jpro) && jpro.length > 0) {
                for (var i = 0; i < jpro.length; i++) {

                    // Defensive extraction to avoid undefined
                    var title   = jpro[i][0] || '';
                    var handle  = jpro[i][2] || '';
                    var variant = jpro[i][5] || '';
                    var price   = jpro[i][7] || '0';

                    p += '<input type="radio" name="addPower" ' +
                        'data-value="' + variant + '" ' +
                        'value="' + handle + '"> ' +
                        '<a target="_blank" href="/products/' + handle + '?variant=' + variant + '">' +
                        title + ' + $' + price +
                        '</a><br>';
                }
            }

            document.getElementById('power-info-detail').innerHTML = p;

        })
        .catch(function(error) {
            console.error("Fetch error:", error);
            document.getElementById('power-info-detail').innerHTML =
                '<div>Unable to load power packs at this time.</div>';
        });

      }
    });
    $('.remove-detail').click(function () {
      $('#remove-info').toggle('slow');
      if ($('#remSymbol').hasClass('rotateDown')) {
        $('#remSymbol').removeClass('rotateDown');
        $('#remove-info').css('border-bottom', 'none');
        $('.remove-detail').css('border-bottom', '1px solid silver');
        $(this).removeClass('backBoxG');
      } else {
        $(this).addClass('backBoxG');
        $('#remSymbol').addClass('rotateDown');
        $('#remove-info').css('border-bottom', '1px solid silver');
        $('.remove-detail').css('border-bottom', 'none');
      }
    });

    $('.free-detail').click(function () {
      let xFreeTitle = $('#freeBox span').html();
      $('#free-info').toggle('slow');
      if ($('#freeSymbol').hasClass('rotateDown')) {
        $('#freeSymbol').removeClass('rotateDown');
        $('#free-info').css('border-bottom', 'none');
        $('.free-detail').css('border-bottom', '1px solid silver');
        $(this).removeClass('backBoxG');
      } else {
        $(this).addClass('backBoxG');
        $('#freeSymbol').addClass('rotateDown');
        $('#free-info').css('border-bottom', '1px solid silver');
        $('.free-detail').css('border-bottom', 'none');
        var vVen = $('#skuItmCd').html();
        
        fetch(
        "https://revyewed.com/cfc/available_cors.cfc?method=remoteGetAddOn"
            + "&sku=" + encodeURIComponent(vVen)
            + "&title=" + encodeURIComponent(xFreeTitle)
            + "&apiKey=" + encodeURIComponent(myApi),
            { method: "GET" }
        )
        .then(function(response) {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            return response.json();
        })
        .then(function(jfree) {

            console.log("Free item JSON:", jfree);

            var p = '<input type="radio" name="addFree" value="NONE" checked> No Item Selected<br>';

            if (Array.isArray(jfree) && jfree.length > 0) {
                for (var i = 0; i < jfree.length; i++) {

                    // Defensive extraction
                    var title   = jfree[i][0] || '';
                    var handle  = jfree[i][2] || '';
                    var variant = jfree[i][5] || '';
                    var value   = jfree[i][7] || '0';

                    p += '<input type="radio" name="addFree" ' +
                        'data-value="' + variant + '" ' +
                        'value="' + handle + '"> ' +
                        '<a target="_blank" href="/products/' + handle + '?variant=' + variant + '">' +
                        title + ' (value $' + value + ')</a><br>';
                }
            }

            document.getElementById('free-info-detail').innerHTML = p;

        })
        .catch(function(error) {
            console.error("Fetch error:", error);
            document.getElementById('free-info-detail').innerHTML =
                '<div>Unable to load free items at this time.</div>';
        });

      }
    });

    $('.mattress-detail').click(function () {
      $('#mattress-info').toggle('slow');
      if ($('#mattSymbol').hasClass('rotateDown')) {
        $('#mattSymbol').removeClass('rotateDown');
        $('#mattress-info').css('border-bottom', 'none');
        $('.mattress-detail').css('border-bottom', '1px solid silver');
        $(this).removeClass('backBoxG');
      } else {
        $(this).addClass('backBoxG');
        $('#mattSymbol').addClass('rotateDown');
        $('#mattress-info').css('border-bottom', '1px solid silver');
        $('.mattress-detail').css('border-bottom', 'none');

      }
    });
    $('.pillow-detail').click(function () {
      $('#pillow-info').toggle('slow');
      if ($('#pillSymbol').hasClass('rotateDown')) {
        $('#pillSymbol').removeClass('rotateDown');
        $('#pillow-info').css('border-bottom', 'none');
        $('.pillow-detail').css('border-bottom', '1px solid silver');
        $(this).removeClass('backBoxG');
      } else {
        $(this).addClass('backBoxG');
        $('#pillSymbol').addClass('rotateDown');
        $('#pillow-info').css('border-bottom', '1px solid silver');
        $('.pillow-detail').css('border-bottom', 'none');
        var vVen = $('#skuItmCd').html();
        var p = '<em>**Gift Card will be added to order after payment is received**</em><br>Mattress & Foundation Purchase $1999 or less = $100 Gift Card<br>Mattress & Foundation Purchase $2,000 or more = $200 Gift Card<br>';
        //for (var i = 0; i < jpro.length; i++) {	
        //p = p + '<a target="_blank" href="/products/'+jpro[i][2]+'?variant='+jpro[i][5]+'"><img src="'+jpro[i][6]+'"><br>'+jpro[i][0]+'</a><br>';	
        //}	
        p = p + '<a target="_blank" href="/products/gift-card"><img src="https://cdn.shopify.com/s/files/1/0081/2505/5034/products/e38bd83af578077b65a31424bd24d085_2000x.png?v=1571363680"><br>Gift Card</a><br>';
        $('#pillow-info-detail').html(p);

        //});	
      }
    });
    $('#moreInfoQuestion').click(function () {
      $('#moreInfoQuestion').fadeOut('slow');
      $('#contactFormZip').focus();
      $('#askQuestion').toggle('slow');
    });
    $(document).on('click', '#foundation-info-detail input:radio', function () {
      var vId = $("input[name='addFoundation']:checked").attr("data-value");
      var theQty = $('.purchase-details #quantity').val();
      if ($('.swatch_options input:checked').val() == 'King') {
        var vQty = theQty * 2;
      } else {
        var vQty = theQty;
      }
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=' + vQty + '&id=' + vId,
        dataType: 'json',
        success: function (s) { },
        error: function (ts) { }
      };
      jQuery.ajax(params);
    });

    $(document).on('click', '#protector-info-detail input:radio', function () {
      var vId = $("input[name='addProtector']:checked").attr("data-value");
      var theQty = $('.purchase-details #quantity').val();
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=' + theQty + '&id=' + vId,
        dataType: 'json',
        success: function (s) { },
        error: function (ts) { }
      };
      jQuery.ajax(params);
    });

    $(document).on('click', '#remove-info-detail input:radio', function () {
      var vId = $("input[name='addRemove']:checked").attr("data-value");
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=1&id=' + vId,
        dataType: 'json',
        success: function (s) { },
        error: function (ts) { }
      };
      jQuery.ajax(params);
    });

    $(document).on('click', '#power-info-detail input:radio', function () {
      var vId = $("input[name='addPower']:checked").attr("data-value");
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=1&id=' + vId,
        dataType: 'json',
        success: function (s) { },
        error: function (ts) { }
      };
      jQuery.ajax(params);
    });

    $(document).on('click', '#free-info-detail input:radio', function () {
      var vId = $("input[name='addFree']:checked").attr("data-value");
      var vQty = $('.purchase-details #quantity').val();
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=' + vQty + '&id=' + vId,
        dataType: 'json',
        success: function (s) { },
        error: function (ts) { }
      };
      jQuery.ajax(params);
    });

    function addProtectionId(id, val) {
      var paramMfs = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=' + val + '&id=' + id,
        dataType: 'json',
        success: function (s) { document.location = '/cart'; },
        error: function (ts) { }
      };
      console.log(paramMfs);
      jQuery.ajax(paramMfs);
    }
    $(document).on('click', '#svDelDt', function () {
      var cdx = $('#salesOrderNumber').html();
      var vCdate = $('#dtSel').val();
      var vCtime = $('#selTimeCustom').val();
      $('.selDtBtn').html('Please wait, scheduling your delivery...');

      const url = `https://revyewed.com/cfc/available_cors.cfc?method=remoteSetCustom`
              + `&doc=${encodeURIComponent(cdx)}`
              + `&date=${encodeURIComponent(vCdate)}`
              + `&time=${encodeURIComponent(vCtime)}`
              + `&apiKey=${encodeURIComponent(myApi)}`;

      fetch(url, { method: "GET" })
      .then(response => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.json();
      })
      .then(json => {
          console.log("Set custom delivery JSON:", json);

          let code;

          // Handle array-of-arrays: [[0]]
          if (Array.isArray(json) && Array.isArray(json[0])) {
              code = json[0][0];
          }
          // Handle query-style JSON: [{"COLUMN1":0}]
          else if (Array.isArray(json) && json[0] && 'COLUMN1' in json[0]) {
              code = json[0].COLUMN1;
          }
          // Unknown format
          else {
              console.warn("Unexpected JSON format", json);
              $('#dateMessage').html('Unexpected response. Please try again.');
              return;
          }

          if (code === 0) {
              $('.selDtBtn').html(`Thank you, your delivery date (${vCdate}) and time have been confirmed.`);
          } else if (code === 13) {
              $('.selDtBtn').html('This sale can no longer be scheduled for delivery. Please contact your sales professional if you have further questions.');
          } else {
              $('.selDtBtn').html('The date you selected is no longer available. Please select another date or contact your nearest office location to set your requested delivery date.');
          }
      })
      .catch(err => {
          console.error("Fetch error:", err);
          $('.selDtBtn').html('Unable to set delivery date at this time. Please try again later.');
      });
      

    });
    $(document).on('click', '#addProtection', function () {
      var vId = $("input[name='addProtection']:checked").attr("value");
      if ($("input[name='addProtection']:checked").is(':checked')) {
        addProtectionId(vId, 1);
      }
    });
    
    $(document).on('click', '.selectTheDate', function () {
      console.log("selected a date");

      var vIdate = $("input[name='selectTheDate']:checked").val();
      var vField = vIdate.substring(3, 5); // for highlighting
      var vDoc = $('#salesOrderNumber').html();

      $('.availDates').removeClass('selectedDate');
      $('#availDates_' + vField).addClass('selectedDate');

      $('#dateMessage').html('Please wait, scheduling your delivery...');

      const url = `https://revyewed.com/cfc/available_cors.cfc?method=remoteSetDelivery`
          + `&doc=${encodeURIComponent(vDoc)}`
          + `&date=${encodeURIComponent(vIdate)}`
          + `&apiKey=${encodeURIComponent(myApi)}`;

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error(`Network response was not ok: ${response.status}`);
          return response.json();
        })
        .then(json => {
          console.log("Set delivery JSON:", json);

          let code;

          // Handle array-of-arrays: [[0]]
          if (Array.isArray(json) && Array.isArray(json[0])) {
              code = json[0][0];
          }
          // Handle query-style JSON: [{"COLUMN1":0}]
          else if (Array.isArray(json) && json[0] && 'COLUMN1' in json[0]) {
              code = json[0].COLUMN1;
          }
          // Unknown format
          else {
              console.warn("Unexpected JSON format", json);
              $('#dateMessage').html('Unexpected response. Please try again.');
              return;
          }

          // Display messages based on code
          if (code === 0) {
            $('#dateMessage').html(
              `Thank you, you will be notified of your 2 hour delivery window the day before your selected delivery date (${vIdate}) at 7pm via text or email.`
            );
          } else if (code === 13) {
            $('#dateMessage').html(
              'This sale can no longer be scheduled for delivery. Please contact your sales professional if you have further questions.'
            );
            $('#selectDelDate').html('');
            $('#delHeaderText').html('');
          } else {
            $('#dateMessage').html(
              'The date you selected is no longer available. Please select another date or contact your nearest office location to set your requested delivery date.'
            );
          }
        })
        .catch(err => {
          console.error("Fetch error:", err);
          $('#dateMessage').html('Unable to set delivery. Please try again later.');
        });
    });

    $(document).on('click', '.selectThePuDate', function () {
      console.log("selected a pickup date");

      const vIdate = $("input[name='selectThePuDate']:checked").val();
      const vField = vIdate.substring(3, 5); // for highlighting
      const vDoc = $('#salesOrderNumber').html();

      $('.availDates').removeClass('selectedDate');
      $('#availDates_' + vField).addClass('selectedDate');

      $('#dateMessage').html('Please wait, scheduling your pick-up...');

      const url = `https://revyewed.com/cfc/available_cors.cfc?method=remoteSetPickUp`
          + `&doc=${encodeURIComponent(vDoc)}`
          + `&date=${encodeURIComponent(vIdate)}`
          + `&apiKey=${encodeURIComponent(myApi)}`;

      fetch(url)
          .then(res => {
              if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
              return res.json();
          })
          .then(json => {
              console.log("Set pickup JSON:", json);

              const code = json.CODE;

              if (code === 0) {
                  $('#dateMessage').html(`Thank you, your pick-up appointment has been scheduled for ${vIdate}.`);
                  $('#pickupMessage').show();
              } else if (code === 13) {
                  $('#dateMessage').html('This sale can no longer be scheduled for pick-up. Please contact your sales professional.');
                  $('#selectDelDate').html('');
                  $('#delHeaderText').html('');
              } else {
                  $('#dateMessage').html('The date you selected is no longer available. Please select another date or contact your nearest office location.');
              }
          })
          .catch(err => {
              console.error("Fetch error:", err);
              $('#dateMessage').html('Unable to set pick-up. Please try again later.');
          });
    });

    $(document).on('click', '#addToCartProductBtn', function () {
      //area for adding on extra free items or offering up an add on	
      const sku = getSku();
      if (!sku) return;

      fetch(
          "https://revyewed.com/cfc/available_cors.cfc?method=remoteGetAddOn"
          + "&sku=" + encodeURIComponent(sku)
          + "&apiKey=" + encodeURIComponent(myApi),
          { method: "GET" }
      )
      .then(function(response) {
          if (!response.ok) {
              throw new Error("Network response was not ok");
          }
          return response.json();
      })
      .then(function(jsonadd) {
          console.log("Alt add-on JSON:", jsonadd);

          if (Array.isArray(jsonadd) && jsonadd.length > 0 && jsonadd[0][0] !== 'none') {
              const item = jsonadd[0];

              $('#altDes').val(item[5] || '');
              $('#skuPrice').html(item[7] || '');
              $('#skuQty').html(item[9] || '');
              $('#boldUpsellHeading').html(item[8] || '');
              $('.bold-product__title').html(item[0] || '');
              $('.bold-product__description').html(item[6] || '');
              $('.bold-product__image-container').html(
                  '<img src="' + (item[1] || '') + '" alt="" class="bold-product__image">'
              );
              $('#bold-modal').css({ opacity: '100', visibility: 'visible' });
          }
      })
      .catch(function(error) {
          console.error("Fetch error:", error);
          // Optionally hide modal or show fallback
          $('#bold-modal').css({ opacity: '0', visibility: 'hidden' });
      });
    });

    $(document).on('click', '#bold-modal__btn-close', function () {
      $('#bold-modal').css('opacity', '0');
      $('#bold-modal').css('visibility', 'hidden');
    });
    $(document).on('click', '#addOnAddToCart', function () {
      $('#bold-modal').css('opacity', '0');
      $('#bold-modal').css('visibility', 'hidden');
      addProtectionId($('#altDes').val(), $('#skuQty').html());
    });
    $('#moreInfoQuestion').fadeIn('slow');

    if ($(".product_links").is(':contains("Clearance")')) {
      $('.tabs #labWarranty').hide();
    }
    $('#labDetail a').addClass('active');
    $('#tabDetail').show();
    $('#tabDetail').css('list-style', 'none');



    if (window.location.pathname.indexOf('/showroomappointment') != -1) {
      var mSx = getUrlVars()["sn"];
      console.log("atpage", mSx);
      $('#theCal').load('https://revyewed.com/cfc/obj.cfc?method=objApptPicIndex&setparentid=56&sn=' + mSx);
    }
    if (window.location.pathname.indexOf('/account') != -1) {
      var mPay = getUrlVars()["p"];
      if (typeof mPay !== 'undefined') {
        $('#actHdr').html('Thank you for making a payment, it can take up to 2 days for your payment to post');
      }
      var sm = $('#saleCustomerEmail').val();
      var sid = $('#saleCustomerid').val();
      const url = `https://revyewed.com/cfc/available_cors.cfc?method=remoteGetOpenSales`
          + `&id=${encodeURIComponent(sid)}`
          + `&email=${encodeURIComponent(sm)}`;

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error(`Network response was not ok: ${response.status}`);
          return response.json();
        })
        .then(json => {
          console.log("Open Sales JSON:", json);

          if (Array.isArray(json) && json.length > 0) {
            let vBl = '<h4>Sales Orders</h4><table class="collapsible-table"><tr><th>Order</th><th>Date</th><th>Type</th><th style="text-align:right;">Amount</th><th style="text-align:right;">Balance</th></tr>';

            json.forEach(sale => {
              const vT = sale[2] === 'D'
                ? `<a target="_blank" href="https://furniturefair.dispatchtrack.com/track_order/fe362a8/${sale[1]}"><img alt="Track Delivery" src="https://cdn.shopify.com/s/files/1/0081/2505/5034/files/track_delivery.png?8659129090663569901"></a>`
                : 'Pickup';

              vBl += `<tr>
                        <td class="tdSoLink" onclick="populateSoNum('${sale[1]}')">${sale[1]}</td>
                        <td>${sale[0]}</td>
                        <td>${vT}</td>
                        <td style="text-align:right;">${sale[4]}</td>
                        <td style="text-align:right;">${sale[5]}</td>
                      </tr>`;
            });

            vBl += '</table>';
            $('#customer_orders').html(vBl);
          } else {
            $('#customer_orders').html('<div>No open sales orders found.</div>');
          }
        })
        .catch(err => {
          console.error("Fetch error:", err);
          $('#customer_orders').html('<div>Unable to retrieve open sales. Please try again later.</div>');
        });


      $('.customerPortal').click(function () {
        $('#stockSymbol').addClass('rotateDown');
        $(".customerSale").toggle("slow", function () {
        });
      });
      $('.billPayPortal').click(function () {
        $('#billSymbol').addClass('rotateDown');
        $(".billPaySale").toggle("slow", function () {
        });
      });
    }

    if (window.location.pathname.indexOf('/addprotection') != -1) {
      let mProtectId = getUrlVars()["id"];
      let mSo = getUrlVars()["doc"];
      if (mProtectId != '') {
        let paramMfsAdd = {
          type: 'POST',
          url: '/cart/add.js',
          data: `quantity=1&id=${mProtectId}`,
          dataType: 'json',
          success: function (s) { document.location = `/cart?doc=${mSo}`; },
          error: function (ts) { }
        };
        jQuery.ajax(paramMfsAdd);
      }
    }
    var mSoDoc = '-';
    if (window.location.pathname.indexOf('/cart') != -1) {
      mSoDoc = getUrlVars()["doc"];
      var params = {
        type: 'GET',
        url: '/cart.js',
        data: '',
        dataType: 'json',
        success: function (s) { },
        error: function (ts) { }
      };
      $.getJSON("/cart.js", function (json2) {
        // Build an array of item objects
        const itemsArray = json2.items.map(item => ({
          id: item.product_id,
          variant_id: item.variant_id,
          price: item.discounted_price,
          qty: item.quantity
        }));

        // If you want to mimic your old extra empty object at the end
        itemsArray.push({ id: "", variant_id: "" });

        // Prepare data to send as form-encoded
        const sendData = new URLSearchParams();
        sendData.append('items', JSON.stringify(itemsArray));

        // Now call the CFC using fetch
        fetch('https://revyewed.com/cfc/available_cors.cfc?method=remoteGetMfsPlans', {
          method: 'POST',
          body: sendData
        })
          .then(response => {
            if (!response.ok) throw new Error(`Network response was not ok: ${response.status}`);
            return response.json();
          })
          .then(json3 => {
            console.log("MFS JSON:", json3);
            if (json3 && json3[0] && json3[0][1] > 0) {
              const sPro = `
                <span>ACCIDENTS HAPPEN - </span>
                Protect your furniture and your investment with our Premium Plus Protection Plan for only 
                <span>$${json3[0][1]}.</span>
                <div class="addprotectplan">
                  <input type="checkbox" name="addProtection" id="addProtection" value="${json3[0][2]}"> 
                  <span>Yes I want the Protection Plan</span><br>
                  <a href="/blogs/lc/furniture-protection-plan-faq?_pos=1&_sid=5851cdd06&_ss=r" target="_blank">
                    I have read the plan information.
                  </a>
                </div>
                <div class="delDisclaimer">
                  <a href="/blogs/lc/furniture-protection-plan-faq?_pos=1&_sid=5851cdd06&_ss=r" target="_blank">
                    &#10148; Read more about this plan
                  </a>
                </div>
              `;
              document.getElementById('mfsArea').innerHTML = sPro;
            } else {
              document.getElementById('mfsArea').innerHTML = '';
            }
          })
          .catch(err => {
            console.error("Fetch error:", err);
            document.getElementById('mfsArea').innerHTML = 'Unable to load protection plan. Please try again later.';
          });

        fetch('https://revyewed.com/cfc/available_cors.cfc?method=remoteGetDiscount', {
          method: 'POST',
          body: sendData
        })
          .then(response => {
            if (!response.ok) throw new Error(`Network response was not ok: ${response.status}`);
            return response.json();
          })
          .then(jsondiscr => {
            console.log("Discount JSON:", jsondiscr);

            if (Array.isArray(jsondiscr) && jsondiscr.length > 0 && jsondiscr[0][1] > 0) {
              const sDisc = `Use discount code <span>${jsondiscr[0][0]}</span> for a <span>${jsondiscr[0][1]} ${jsondiscr[0][3]}</span> discount on applicable items at checkout.`;
              $('#mfsArea').before(`<div id="discNote">${sDisc}<hr></div>`);
            }
          })
          .catch(err => {
            console.error("Fetch error:", err);
          });
        //comment out for vets
        //$('#mfsArea').before('<div id="discNote">For Veterans and their family, please use coupon code <b>VETERANS</b> at checkout. We thank you for your service.</div>');	

      });

      const url = `https://revyewed.com/cfc/available_cors.cfc?method=remoteGetSlsp`;

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error(`Network response was not ok: ${response.status}`);
          return response.json();
        })
        .then(json => {
          console.log("Sales associates JSON:", json);

          let s = '<select id="salesassist" name="attributes[salesAssist]">';
          s += '<option value="-">Did a Sales Associate assist you?</option>';
          s += '<option value="TIPT">Online Associate - Chris</option>';

          json.forEach(item => {
            // Assuming item[0] = name, item[1] = code (same as original JSONP structure)
            s += `<option value="${item[1]}">${item[0]}</option>`;
          });

          s += `</select><input type="hidden" name="addToSale" id="addToSale" value="${mSoDoc}">`;

          $('#slspArea').html(s);
        })
        .catch(err => {
          console.error("Fetch error:", err);
          $('#slspArea').html('<p>Unable to load sales associates. Please try again later.</p>');
        });

    };

    $('#designContactSubmit').click(function () {
      var s = $('#contactFormQuestion').val();
      if (s == '2') {
        $("#designSectionContact").toggle("slow", function () {
          $('#designSectionContact').html('<h3>Thank you, someone will contact you.</h3>');
          $('#designSectionContact').toggle("slow");
        });
      }
    });
    $('#on_resume').change(function (e) {
      if (this.value == 'No') {
        $('.EducInfo').show();
      } else {
        $('.EducInfo').hide();
      }
    });

    if (window.location.pathname.indexOf('/order-status') != -1) {
      var mCustId = getUrlVars()["customerid"];
      var mSalesDoc = getUrlVars()["salesOrder"];
      var mStore = mSalesDoc.substring(5, 7);
      var mEmailAddr = getUrlVars()["customeremail"];
      $('#salesOrderNumber').html(mSalesDoc);
      
      const url = `https://revyewed.com/cfc/available_cors.cfc?method=remoteGetSaleInfo`
          + `&doc=${encodeURIComponent(mSalesDoc)}`
          + `&id=${encodeURIComponent(mCustId)}`
          + `&email=${encodeURIComponent(mEmailAddr)}`;

      console.log("Fetching URL:", url);

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error(`Network response was not ok: ${response.status}`);
          return response.json();
        })
        .then(jsonSale => {
          console.log("Sale Info JSON:", jsonSale);
          let delReady = 'Y';
          let vResked = '';
          let vBalDue = '';

          if (Array.isArray(jsonSale) && jsonSale.length > 0) {
            const vdue = parseFloat(Math.round(jsonSale[0][15] * 100) / 100).toFixed(2);

            if (mEmailAddr.length > 5) {
              vBalDue = ` - Balance Due: $${vdue} - ➤<a href="/pages/makepayment?doc=${mSalesDoc}">Make Payment</a>`;
            }

            $('#salesOrderNumber').html(`${mSalesDoc}${vBalDue}`);

            let sqd = '<table><tr><th colspan="4" style="text-align:center;"><h5>';

            if (jsonSale[0][0] === '2049') {
              sqd += `Your ${jsonSale[0][7]} date has not yet been scheduled.</h5></th>`;
            } else {
              if (jsonSale[0][14] === 'O') {
                sqd += `<h5>Your ${jsonSale[0][7]} date is scheduled for ${jsonSale[0][8]} ${jsonSale[0][9]} ${jsonSale[0][10]}.</h5></th>`;
                vResked = 'RE';
              } else {
                sqd += '<h5>This sale is completed, no further changes can be made.</h5></th>';
              }
            }

            for (let i = 0; i < jsonSale.length; i++) {
              if (jsonSale[i][4] !== 'none') {
                sqd += `<tr><td class="cI"><img class="smallImg" src="${jsonSale[i][4]}"></td><td class="cI">`;
              } else {
                sqd += '<tr><td class="cI"></td><td class="cI">';
              }

              sqd += `${jsonSale[i][1]}<br>Qty: ${jsonSale[i][11]}</td><td>${jsonSale[i][2]}</td>`;

              if (jsonSale[i][3] === 'cbo') {
                if (jsonSale[i][6] === 'INV') delReady = 'N';

                if (mStore === 'KH') {
                  if (jsonSale[i][5] != null) {
                    const skedDate = jsonSale[i][5];
                    sqd += `<td class="cI">Estimated Arrival to our Warehouse: ${skedDate.replace("00:00:00", "")}</td>`;
                  } else {
                    if (jsonSale[i][6] === 'PKG') sqd += '<td></td>';
                    else sqd += '<td class="cI">Arrival status unavailable at this time.</td>';
                  }
                } else {
                  sqd += '<td class="cI">Arrival status unavailable at this time.</td>';
                }
              } else {
                if (jsonSale[0][14] === 'O') sqd += '<td class="cI">In Stock Waiting</td>';
                else sqd += '<td class="cI">&#10004;</td>';
              }
            }

            sqd += '</tr>';

            // Delivery links
            if (delReady === 'Y' && jsonSale[0][7] === 'Delivery' && jsonSale[0][13] == null && jsonSale[0][15] == 0 && jsonSale[0][14] === 'O') {
              if (mEmailAddr.length > 5) {
                sqd += `<tr><th colspan="4" style="text-align:center;"><h5><a href="/pages/select-delivery-date/?doc=${mSalesDoc}&zip=${jsonSale[0][12]}">➤ ${vResked}Schedule Your Delivery</a></h5></th></tr>`;
              }
            } else if (jsonSale[0][7] === 'Delivery' && jsonSale[0][13] != null) {
              sqd += `<tr><th colspan="4" style="text-align:center;"><h5><a href="https://furniturefair.dispatchtrack.com/track_order/fe362a8/${mSalesDoc}">➤ Track Your Delivery</a></h5></th></tr>`;
            }

            sqd += '</table>';
            $('#orderData').html(sqd);
          } else {
            const sqd = '<div class="availDates">We are unable to retrieve your order status, please contact your sales professional for information about this order.</div>';
            $('#orderData').html(sqd);
          }
        })
        .catch(err => {
          console.error("Fetch error:", err);
          $('#orderData').html('<div class="availDates">Unable to retrieve order info. Please try again later.</div>');
        });

    }

    if (window.location.pathname.indexOf('/select-delivery-date') != -1) {

      var vDocNum = getUrlVars()["doc"];
      //var vZipCode = getUrlVars()["zip"];	
      if (getUrlVars()["zip"]) {
        var vZipCode = getUrlVars()["zip"];
      } else {
        var vZipCode = '1';
      }
      $('#salesOrderNumber').html(vDocNum);
      
      const url = `https://revyewed.com/cfc/available_cors.cfc?method=remoteGetAvailDel`
          + `&zip=${encodeURIComponent(vZipCode)}`
          + `&doc=${encodeURIComponent(vDocNum)}`
          + `&apiKey=${encodeURIComponent(myApi)}`;

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error(`Network response was not ok: ${response.status}`);
          return response.json();
        })
        .then(json => {
          console.log("Available delivery JSON:", json);

          let s = '';

          if (json && json.length > 0 && json[0][0] !== 'none') {

            if (json[0][5] != null || json[0][6] === 'n') {
              s = '<div><h5>Your delivery is already scheduled on a truck and cannot be changed.</h5></div>';
            } else if (json[0][4] !== 'Custom') {
              for (let i = 0; i < json.length; i++) {
                const shortDate = json[i][2].substring(0, 2);
                s += `<div class="availDates" id="availDates_${shortDate}">
                        <input type="radio" class="selectTheDate" name="selectTheDate" value="${json[i][3]}" /> - ${json[i][0]} ${json[i][1]} ${json[i][2]}
                      </div>`;
              }
            } else {
              s = '<div class="delSelectDiv"><span class="messageData">Select Your Date:</span><br><select name="dtSel" id="dtSel" class="delSelect">';	
              for (var i = 0; i < json.length; i++) {	
                s = s + '<option value="'+json[i][3]+'">'+json[i][0]+' '+json[i][1]+' '+json[i][2]+'</option>';	
              }	
              s = s + '</select></div><div class="delSelectDiv"><span class="messageData">Select Your Time:</span><br><select class="delSelect" id="selTimeCustom" name="selTimeCustom"><option value="32440-39640">9am - 11am</option>'; 	
              s = s + '<option value="36040-43240">10am - 12noon</option><option value="39640-46840">11am - 1pm</option><option value="43240-50440">12noon - 2pm</option><option value="46840-54040">1pm - 3pm</option>';	
              s = s + '<option value="50440-57640">2pm - 4pm</option><option value="54040-61240">3pm - 5pm</option><option value="57640-64840">4pm - 6pm</option><option value="61240-68440">5pm - 7pm</option>';	
              s = s + '</select></div><div class="selDtBtn"><button id="svDelDt">Save Delivery Choices</button></div>';	
              }

          } else {
            $('#delHeaderText').html('Enter the sales order number sent to you in your email or text message.');
            $('#getAvailDates').show();
          }

          // Inject HTML first
          $('#selectDelDate').html(s);

        })
        .catch(err => {
          console.error("Fetch error:", err);
          $('#delHeaderText').html('Unable to load available delivery dates. Please try again later.');
          $('#selectDelDate').html('');
        });


    }

    if (window.location.pathname.indexOf('/set-pickup-appointment') != -1) {
      var vDocNum = getUrlVars()["doc"];
      var s = '';
      $('#salesOrderNumber').html(vDocNum);
      // Build the URL with document number and API key
      const url = `https://revyewed.com/cfc/available_cors.cfc?method=remoteGetAvailpuDay`
                + `&doc=${encodeURIComponent(vDocNum)}`
                + `&apiKey=${encodeURIComponent(myApi)}`;

      // Fetch the JSON from your CFC endpoint
      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error(`Network response was not ok: ${response.status}`);
          return response.json();
        })
        .then(json => {
          console.log("Available pickup days JSON:", json);

          let s = ''; // Initialize the HTML output

          // Validate JSON structure
          if (!json || !json.DATE || !json.DAY || !Array.isArray(json.DATE) || !Array.isArray(json.DAY)) {
            $('#delHeaderText').html('Unexpected response. Please try again.');
            $('#getAvailDates').show();
            $('#selectDelDate').html('');
            return;
          }

          // No pickup dates available
          if (json.DATE[0] === 'none') {
            $('#delHeaderText').html('Enter the sales order number sent to you in your email or text message.');
            $('#getAvailDates').show();
          } else {
            // Loop through all available dates dynamically
            for (let i = 0; i < json.DATE.length; i++) {
              const date = json.DATE[i];
              const day  = json.DAY[i];

              // Skip blocked or undefined dates
              if (date && date !== '11/26/2020' && date !== '12/24/2020' && date !== '12/25/2020') {
                s += `<div class="availDates" id="availDates_${date}">
                        <input type="radio" class="selectThePuDate" name="selectThePuDate" value="${date}" /> - ${day}
                      </div>`;
              }
            }
          }

          // Inject the generated HTML into the page
          $('#selectDelDate').html(s);
        })
        .catch(err => {
          console.error("Fetch error:", err);
          $('#delHeaderText').html('Unable to load available pickup dates. Please try again later.');
          $('#selectDelDate').html('');
        });


    }

    if (window.location.pathname.indexOf('/unsubscribe') != -1) {
      $('#unSubscribeEmail ').click(function () {
        var unEmail = $('#emailAddrUn').val();

        // Assuming unEmail is defined
        const url = `https://revyewed.com/cfc/available_cors.cfc?method=remoteRemoveEmail&em=${encodeURIComponent(unEmail)}`;

        fetch(url)
          .then(response => {
            if (!response.ok) throw new Error(`Network response was not ok: ${response.status}`);
            return response.json(); // Expecting the CFC to return valid JSON
          })
          .then(json => {
            console.log("Remove Email JSON:", json);
            $('#unEmailMsg').html('<strong>We have flagged your email for removal. If you need to make changes to this please contact your nearest showroom location.</strong>');
          })
          .catch(err => {
            console.error("Fetch error:", err);
            $('#unEmailMsg').html('<strong>Unable to remove email. Please try again later.</strong>');
          });

      });
    }

    $('#getDelDatesBtn').click(function () {
      var sdx = $('#deldoc').val();
      document.location = '/pages/select-delivery-date/?doc=' + sdx + '&zip=1';
    });

    $('#getPuDatesBtn').click(function () {
      var sdx = $('#deldoc').val();
      document.location = '/pages/set-pickup-appointment/?doc=' + sdx;
    });
    function getUrlVars() {
      var vars = {};
      var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
      });
      return vars;
    }

    //MTG ADDED END 
  });
})(jQuery);